import Snackbar from "../../scripts/snackbar";
import {NAVIGATION_PATH} from "../../enums/navigation_enum";
import config from '../../scripts/config';

export const isComponentDisabledForUpdates = (permissionMap, component_key) => {
    if (permissionMap && permissionMap.has(component_key)) {
        return !permissionMap.get(component_key).includes("WRITE");
    }
    return true;
};

export const hasPermission = (permissionMap, component_key, checkWrite) => {
    if (permissionMap && permissionMap.has(component_key)) {
        if (checkWrite) {
            return permissionMap.get(component_key).includes("WRITE");
        } else {
            return true;
        }
    }
    return false;
};

export function getLoginStatus(login) {
    if (!login) {
        return 0;
    }

    if (login.expiry >= (new Date()).getTime() / 1000) {
        return 1; // logged in and access token valid
    }

    if (login.expiry_refresh && login.expiry_refresh >= (new Date()).getTime() / 1000) {
        return 2; // logged in, but has to be refreshed
    }

    return 0;
}

export async function refresh(login, setLogin) {
    const res = await fetch(
        config.REACT_APP_HOST + "/api/refresh",
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + login.refresh_token},
            body: JSON.stringify({}),
            credentials: 'include'
        })
    if (res.ok) {
        const content = await res.json();
        
        // Always update login state with new tokens
        const updatedLogin = {...login, ...content};
        setLogin(updatedLogin);
        
        // Check if user needs to accept platform terms & conditions
        if (content.requires_terms_acceptance) {
            // Preserve the session so user can accept T&C with valid tokens
            Snackbar.info("Please accept the Terms & Conditions to continue");
            window.location.replace(NAVIGATION_PATH.LOGIN_PATH);
            return;
        }
        
        window.location.reload()
    } else {
        Snackbar.error("Password token refresh failed");
        setLogin({})
        window.location.replace(NAVIGATION_PATH.LOGIN_PATH);
    }
}

export async function getErrorMessage(response) {
    const cl = response.clone()
    const result = await cl.json()
    return result
}

export async function authfetch(url, args, login, setLogin) {
    if (getLoginStatus(login) === 2) { // refresh because of frontend check
        await refresh(login, setLogin)
    }

    args = updateAuthHeader(args, login)
    let res = await fetch(url, args)

    if (!res.ok) { // any 2XX code
        if (res.status === 422) {
            // retry refresh because of backend check
            res = await retryAuthFetch(url, args, login, setLogin, res)
        }
        if (!res.ok) {
            // Throw the error if you want to handle it using react query
            const errorData = await getErrorMessage(res) || { msg: 'Unknown Error' }
            console.error(`HTTP Error: ${res.status} - ${errorData.msg || errorData}`)
            const error = new Error(errorData.msg || 'Unknown Error')
            error.status = res.status
            error.data = errorData
            throw error
        }
    }

    //def refresh_expiring_jwts
    if (res.headers.get('Access-Token')) {
        login["access_token"] = res.headers.get('Access-Token')
        login["expiry"] = res.headers.get('Access-Token-Expiry')
    }

    return res;
}

async function retryAuthFetch(url, args, login, setLogin, res) {
    const first_result = await res.json();
    if (first_result.success === -1) {
        await refresh(login, setLogin)
        args = updateAuthHeader(args, login)
        return await fetch(url, args)
    } else {
        setLogin({})
        window.location.replace(NAVIGATION_PATH.LOGIN_PATH);
        Snackbar.error("Login status invalid");
    }
}

function updateAuthHeader(args, login) {
    if (args === undefined) {
        args = {}
    }

    if ('headers' in args) {
        args.headers["Authorization"] = 'Bearer ' + login.access_token
        args.headers["cache"] = "no-store"
    } else {
        args["headers"] = {'Authorization': 'Bearer ' + login.access_token, cache: "no-store"}
    }
    return args
}

export async function tryLogin(username, password, keepLoggedIn, setLogin) {

    try {
        const f = await fetch(
            config.REACT_APP_HOST + "/api/login",
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({username: username, password: password, keepLoggedIn: keepLoggedIn ? 1 : 0}),
                credentials: 'include'
            })

        const d = await f.json();

        if (f.status !== 200 || d.success !== 1) {
            Snackbar.error(d.msg);
            return {success: false};
        }
        
        Snackbar.success("Login success");
        setLogin(d);
        
        // Return success and T&C requirement status
        return {
            success: true,
            requiresTerms: d.requires_terms_acceptance || false,
            termsData: d.terms_and_conditions || null
        };
    } catch (e) {
        console.error(e)
    }

    return {success: false};
}

export async function tryLogout(setLogin) {
    setLogin({})

    return true;
}